import React, { FC } from 'react';

import {
  DatetimeFormatType,
  DatetimeMonthFormat,
  FormatDateValueType,
  FriendlyAdditions,
  TypeOfDate,
} from 'app/lib/datetime/types';

import { useTranslation } from 'app/lang';
import { formatDate, formatValueToDate } from 'app/lib/datetime';

export type DatetimeProps = {
  format: DatetimeFormatType;
  friendlyFormat?: FriendlyAdditions;
  monthFormat?: DatetimeMonthFormat;
  value?: FormatDateValueType | null;
  typeOfDate?: TypeOfDate;
  className?: string;
  title?: string;
  'data-test'?: string;
  withoutYear?: boolean;
};

const Datetime: FC<DatetimeProps> = ({
  value,
  format,
  friendlyFormat,
  monthFormat,
  typeOfDate,
  className,
  title,
  withoutYear,
  ...props
}) => {
  const { lang } = useTranslation();

  if (!value) {
    return null;
  }

  const date = formatValueToDate(value);

  return (
    <time dateTime={date.toISOString()}
          className={className}
          title={title}
          data-test={props['data-test']}>
      {
        formatDate(
          date,
          format,
          lang,
          {
            monthFormat,
            friendlyFormat,
            typeOfDate,
            withoutYear,
          },
        )
      }
    </time>
  );
};

export default Datetime;
